module.exports = __webpack_public_path__ + "img/docx.fw.7e5a99bf.png";